export default {
  fr: "Français",
  // ar: "العربية"
}